var _a;
const e = up.element;
const u = up.util;
up.Layer.Overlay = (_a = class Overlay extends up.Layer {
        keys() {
            return [
                ...super.keys(),
                ...this.constructor.VISUAL_KEYS,
                'onOpened',
                'onAccept',
                'onAccepted',
                'onDismiss',
                'onDismissed',
                'acceptEvent',
                'dismissEvent',
                'acceptLocation',
                'dismissLocation',
                'acceptFragment',
                'dismissFragment',
            ];
        }
        constructor(options) {
            super(options);
            this.state = 'opening';
            if (this.dismissible === true) {
                this.dismissible = ['button', 'key', 'outside'];
            }
            else if (this.dismissible === false) {
                this.dismissible = [];
            }
            else {
                this.dismissible = u.getSimpleTokens(this.dismissible);
            }
            if (this.acceptLocation) {
                this.acceptLocation = new up.URLPattern(this.acceptLocation);
            }
            if (this.dismissLocation) {
                this.dismissLocation = new up.URLPattern(this.dismissLocation);
            }
        }
        callback(name) {
            let fn = this[name];
            if (fn) {
                return fn.bind(this);
            }
        }
        createElement(parentElement) {
            this.nesting || (this.nesting = this._suggestVisualNesting());
            const elementAttrs = u.compactObject(u.pick(this, ['align', 'position', 'size', 'class', 'nesting']));
            this.element = this.affixPart(parentElement, null, elementAttrs);
        }
        createBackdropElement(parentElement) {
            this.backdropElement = this.affixPart(parentElement, 'backdrop');
        }
        createViewportElement(parentElement) {
            this.viewportElement = this.affixPart(parentElement, 'viewport', { 'up-viewport': '' });
        }
        createBoxElement(parentElement) {
            this.boxElement = this.affixPart(parentElement, 'box');
        }
        createContentElement(parentElement) {
            this.contentElement = this.affixPart(parentElement, 'content');
        }
        setContent(content) {
            this.contentElement.append(content);
            this.onContentSet();
        }
        onContentSet() {
        }
        createDismissElement(parentElement) {
            this.dismissElement = this.affixPart(parentElement, 'dismiss', {
                'up-dismiss': '":button"',
                'aria-label': this.dismissARIALabel
            });
            return e.affix(this.dismissElement, 'span[aria-hidden="true"]', { text: this.dismissLabel });
        }
        affixPart(parentElement, part, options = {}) {
            return e.affix(parentElement, this.selector(part), options);
        }
        static selector(part) {
            return u.compact(['up', this.mode, part]).join('-');
        }
        _suggestVisualNesting() {
            const { parent } = this;
            if (this.mode === parent.mode) {
                return 1 + parent._suggestVisualNesting();
            }
            else {
                return 0;
            }
        }
        setupHandlers() {
            var _b, _c;
            super.setupHandlers();
            this.overlayFocus = new up.OverlayFocus(this);
            if (this._supportsDismissMethod('button')) {
                this.createDismissElement(this.getBoxElement());
            }
            if (this._supportsDismissMethod('outside')) {
                if (this.viewportElement) {
                    up.on(this.viewportElement, 'up:click', (event) => {
                        if (event.target === this.viewportElement) {
                            this._onOutsideClicked(event, true);
                        }
                    });
                }
                else {
                    this._unbindParentClicked = this.parent.on('up:click', (event, element) => {
                        if (!up.layer.isWithinForeignOverlay(element)) {
                            const originClicked = this.origin && this.origin.contains(element);
                            this._onOutsideClicked(event, originClicked);
                        }
                    });
                }
            }
            if (this._supportsDismissMethod('key')) {
                this._unbindEscapePressed = up.event.onEscape((event) => this.onEscapePressed(event));
            }
            this.registerAttrCloser('up-accept', (value, closeOptions) => {
                this.accept(value, closeOptions);
            });
            this.registerAttrCloser('up-dismiss', (value, closeOptions) => {
                this.dismiss(value, closeOptions);
            });
            (_c = (_b = up.migrate).registerLayerCloser) === null || _c === void 0 ? void 0 : _c.call(_b, this);
            this._registerExternalEventCloser(this.acceptEvent, this.accept);
            this._registerExternalEventCloser(this.dismissEvent, this.dismiss);
            this.on('up:click', 'label[for]', (event, label) => this._onLabelForClicked(event, label));
        }
        _onLabelForClicked(event, label) {
            let id = label.getAttribute('for');
            let fieldSelector = up.form.fieldSelector(e.idSelector(id));
            let fieldsAnywhere = up.fragment.all(fieldSelector, { layer: 'any' });
            let fieldsInLayer = up.fragment.all(fieldSelector, { layer: this });
            if (fieldsAnywhere.length > 1 && fieldsInLayer[0] !== fieldsAnywhere[0]) {
                event.preventDefault();
                const field = fieldsInLayer[0];
                field.focus();
                if (field.matches('input[type=checkbox], input[type=radio]')) {
                    field.click();
                }
            }
        }
        _onOutsideClicked(event, halt) {
            up.log.putsEvent(event);
            if (halt)
                up.event.halt(event);
            up.error.muteUncriticalSync(() => this.dismiss(':outside', { origin: event.target }));
        }
        onEscapePressed(event) {
            if (this.isFront()) {
                let field = up.form.focusedField();
                if (field) {
                    field.blur();
                }
                else if (this._supportsDismissMethod('key')) {
                    up.event.halt(event, { log: true });
                    up.error.muteUncriticalSync(() => this.dismiss(':key'));
                }
            }
        }
        registerAttrCloser(attribute, closeFn) {
            this._registerClickCloser(attribute, closeFn);
            this._registerSubmitCloser(attribute, closeFn);
        }
        _registerClickCloser(attribute, closeFn) {
            this.on('up:click', `[${attribute}]:not(form)`, (event, link) => {
                up.event.halt(event, { log: true });
                const value = e.jsonAttr(link, attribute);
                this._onAttrCloserActivated(link, value, closeFn);
            });
        }
        _registerSubmitCloser(attribute, closeFn) {
            this.on('submit', `[${attribute}]`, (event, form) => {
                up.event.halt(event, { log: true });
                const value = up.Params.fromForm(form);
                this._onAttrCloserActivated(form, value, closeFn);
            });
        }
        _onAttrCloserActivated(origin, value, closeFn) {
            const closeOptions = { origin };
            const parser = new up.OptionsParser(origin, closeOptions);
            parser.booleanOrString('animation');
            parser.string('easing');
            parser.number('duration');
            parser.string('confirm');
            up.error.muteUncriticalSync(() => closeFn(value, closeOptions));
        }
        _registerExternalEventCloser(eventTypes, closeFn) {
            if (!eventTypes) {
                return;
            }
            return this.on(eventTypes, (event) => {
                event.preventDefault();
                up.error.muteUncriticalSync(() => closeFn.call(this, event, { response: event.response }));
            });
        }
        tryAcceptForElements(newElements, response) {
            this._tryCloseForElements(this.acceptFragment, this.accept, newElements, response);
        }
        tryDismissForElements(newElements, response) {
            this._tryCloseForElements(this.dismissFragment, this.dismiss, newElements, response);
        }
        _tryCloseForElements(selector, closeFn, newElements, response) {
            let match = u.findResult(newElements, (element) => e.subtreeFirst(element, selector));
            if (match) {
                const closeValue = up.data(match);
                up.error.muteUncriticalSync(() => closeFn.call(this, closeValue, { response }));
            }
        }
        tryAcceptForLocation(newLocation, response) {
            this._tryCloseForLocation(newLocation, this.acceptLocation, this.accept, response);
        }
        tryDismissForLocation(newLocation, response) {
            this._tryCloseForLocation(newLocation, this.dismissLocation, this.dismiss, response);
        }
        _tryCloseForLocation(newLocation, urlPattern, closeFn, response) {
            let resolution = newLocation && (urlPattern === null || urlPattern === void 0 ? void 0 : urlPattern.recognize(newLocation));
            if (resolution) {
                const closeValue = Object.assign(Object.assign({}, resolution), { location: newLocation });
                up.error.muteUncriticalSync(() => closeFn.call(this, closeValue, { response }));
            }
        }
        teardownHandlers() {
            var _b, _c;
            super.teardownHandlers();
            (_b = this._unbindParentClicked) === null || _b === void 0 ? void 0 : _b.call(this);
            (_c = this._unbindEscapePressed) === null || _c === void 0 ? void 0 : _c.call(this);
        }
        destroyElements(options) {
            const animationProps = this.closeAnimationProps(options);
            const onFinished = () => {
                var _b;
                this.onElementsRemoved();
                (_b = options.onFinished) === null || _b === void 0 ? void 0 : _b.call(options);
            };
            up.destroy(this.element, Object.assign(Object.assign(Object.assign({}, options), animationProps), { onFinished, log: false }));
        }
        onElementsRemoved() {
        }
        _animationFn(boxAnimation, backdropAnimation) {
            if (up.motion.isNone(boxAnimation))
                return false;
            backdropAnimation = this.backdrop && backdropAnimation;
            return (_element, animateOptions) => {
                const boxDone = up.animate(this.getBoxElement(), boxAnimation, animateOptions);
                const backdropDone = up.animate(this.backdropElement, backdropAnimation, animateOptions);
                return Promise.all([boxDone, backdropDone]);
            };
        }
        startOpenAnimation(options = {}) {
            const animationProps = this.openAnimationProps(options);
            const onFinished = () => {
                var _b;
                this.wasEverVisible = true;
                (_b = options.onFinished) === null || _b === void 0 ? void 0 : _b.call(options);
            };
            return up.animate(this.element, animationProps.animation, Object.assign(Object.assign({}, animationProps), { onFinished }));
        }
        openAnimationProps(options = {}) {
            var _b;
            let boxAnimation = (_b = options.animation) !== null && _b !== void 0 ? _b : this.evalOption(this.openAnimation);
            let backdropAnimation = 'fade-in';
            let animationFn = this._animationFn(boxAnimation, backdropAnimation);
            return {
                animation: animationFn,
                easing: options.easing || this.openEasing,
                duration: options.duration || this.openDuration,
            };
        }
        closeAnimationProps(options = {}) {
            var _b, _c;
            let boxAnimation = this.wasEverVisible && ((_b = options.animation) !== null && _b !== void 0 ? _b : this.evalOption(this.closeAnimation));
            let backdropAnimation = 'fade-out';
            let animationFn = this._animationFn(boxAnimation, backdropAnimation);
            return {
                animation: animationFn,
                easing: options.easing || this.closeEasing,
                duration: (_c = options.duration) !== null && _c !== void 0 ? _c : this.closeDuration,
            };
        }
        isAlive() {
            return ['opening', 'opened'].includes(this.state);
        }
        accept(value = null, options = {}) {
            return this._executeCloseChange('accept', value, options);
        }
        dismiss(value = null, options = {}) {
            return this._executeCloseChange('dismiss', value, options);
        }
        _supportsDismissMethod(method) {
            return u.contains(this.dismissible, method);
        }
        _executeCloseChange(verb, value, options) {
            options = Object.assign(Object.assign({}, options), { verb, value, layer: this });
            return new up.Change.CloseLayer(options).execute();
        }
        getFirstSwappableElement() {
            return this.getContentElement().children[0];
        }
        toString() {
            return `${this.mode} overlay`;
        }
    },
    _a.VISUAL_KEYS = [
        'mode',
        'position',
        'align',
        'size',
        'origin',
        'class',
        'backdrop',
        'dismissible',
        'dismissLabel',
        'dismissARIALabel',
        'openAnimation',
        'closeAnimation',
        'openDuration',
        'closeDuration',
        'openEasing',
        'closeEasing',
        'trapFocus',
    ],
    _a.UNSET_VISUALS = u.spanObject(_a.VISUAL_KEYS, undefined),
    _a);
